export default __webpack_public_path__ + "locales/de/DeleteProfileEverDialog.json?hash=e0848ab3d6e7a2fbd58a1db9fadc0d60";